import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import { Widget } from '@ispm/widgets/decorator/widget.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IspmHttpClient } from '@ispm/core/services/ispm-http-client';
import { HttpInterceptorService } from '@ispm/core/services/http-interceptor.service';
import { Subject } from 'rxjs';
import { FormGroup } from '@angular/forms';
import { UserActionCreatorService } from '@ispm/user/services/user-action-creator.service';
import { FileService } from '@ispm-client/modules/file-module/services/file.service';
import { DynamicApiService } from '../../../../app/export/services/dynamic-api.service';
import { CryptoService } from '@ispm/migration/services/crypto.service';
import { NotificationMessageService } from '@ispm/core/components/customise-notification/notifications-message.service';


@Component({
  selector: 'gen-upload-report-template',
  templateUrl: './upload-report-template.component.html',
  styleUrls: ['./upload-report-template.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@Widget('upload-report-template')
export class UploadReportTemplateComponent implements OnInit, OnDestroy, IWidgetItem<any> {

  private key: string;
  private iterations: number;
  public _formConfig: Array<any>;
  public widgetFormInstance: FormGroup;
  private _widgetFormInstanceSubmitted: boolean;

  public widgetPayload: any;
  private destroyed$: Subject<any> = new Subject();
  public inputConfig = [];
  widgetUpdateValueCallback: (value) => void;
  widgetSubmitStatusValueCallback: (value: boolean) => void;
  public listenToDataChange = true;
  public formData: any;
  private submitUri = 'reporttemplate/upload';
  private report: any;
  public fileName: any;
  private application: string;
  private test: string;
  private type: string;
  private status: string;
  private file: any;
  private templateName: string;
  private fileJson: any;
  constructor(private _ispmHttpClient: IspmHttpClient,
              private _isgHttpClient: HttpInterceptorService,
              private notificationMessageService: NotificationMessageService,
              private _changeDetector: ChangeDetectorRef,
              private _UserActionCreatorService: UserActionCreatorService,
              private _dynamicApiService: DynamicApiService,
              private _fileService: FileService,
              private cryptoService: CryptoService) {
  }

  ngOnInit() {
  }

  set widgetData(widgetData: any) {
    this.formData = widgetData;
    if (this.formData) {
      this._changeDetector.markForCheck();
    }

  }
  set widgetConfig(widgetConfig) {

    this.widgetPayload = widgetConfig.widgetPayload;
    this._formConfig = this.widgetPayload.formConfig;
  }


  public get widgetFormInstanceSubmitted() {
    return this._widgetFormInstanceSubmitted;
  }

  public formUpdate(form) {
/*    this.application = form.application;
    this.test = form.test;*/
    this.templateName = form.templateName;
    this.type = form.type;
    this.file = form.file;
    this.fileJson = form.fileJson;
    this._changeDetector.markForCheck();
  }

  public set widgetFormInstanceSubmitted(widgetFormInstanceSubmitted: boolean) {
    this._widgetFormInstanceSubmitted = widgetFormInstanceSubmitted;
    this._changeDetector.markForCheck();
    this.uploadReportTemplate();
  }

  public uploadReportTemplate() {
      const body = {
        templateName : this.templateName,
        test : this.test,
        type : this.type,
        status : 'draft',
        file : this.file.referenceId,
        json : this.fileJson.referenceId,
        orgId : JSON.parse(sessionStorage.getItem('Orgnization')).id,
        user : JSON.parse(localStorage.getItem('user')).username
      };

      this._ispmHttpClient.post(this.submitUri, body).subscribe(
        result => {
          this._dynamicApiService.setReloadWorklistStatus(true);
          this.notificationMessageService.success('Template created successfully');
          console.log('Template Uploaded succeeded', result);
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
        },
        error => {
          this.widgetSubmitStatusValueCallback.apply(this, [false]);
          this.notificationMessageService.error('Failed to Upload Template' + this.getErrorMessage(error.message));
          console.log('Template upload error', error);
        }
      );
    this._changeDetector.markForCheck();
  }
  private getErrorMessage(msg: string) {
    const msgs = msg.split(':');
    return msgs[msgs.length - 1];
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    this._changeDetector.detach();
  }
}


